'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbSearchResultsController.$inject = ['SearchConstants'];


var _module = _angular2.default.module('cb.core.search.cbSearchResultsController', []);

_module.controller('cbSearchResultsController', cbSearchResultsController);

exports.default = _module;


function cbSearchResultsController(SearchConstants) {
    var vm = this;

    vm.linkTarget = SearchConstants.LINK_TARGET;
    vm.enableOrderBy = SearchConstants.ENABLE_ORDER_BY;
    vm.refinementStyle = SearchConstants.REFINEMENT_STYLE;

    init();

    function init() {
        require('./vendor/google-search.js');
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/search/cb-search-results.controller.js
// module id = 820
// module chunks = 0